'use client';

import type { PropsWithChildren } from 'react';

import { SnackbarProvider } from 'notistack';

export const NotiStackProvider: React.FC<PropsWithChildren> = ({
    children,
}) => {
    return (
        <SnackbarProvider
            classes={{ containerRoot: 'z-alert' }}
            maxSnack={3}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            autoHideDuration={5000}
        >
            {children}
        </SnackbarProvider>
    );
};
